<template>
  <StandardCardPageContainer>
    <v-form>
      <div v-if="!viewUser">
        <v-row>
          <v-col>
            <h1 class="mb-8">Create User</h1>
          </v-col>
        </v-row>
        <div class="text-left">
          <p class="mb-5 mt-3">Please enter user information</p>
          <v-row>
            <v-col>
              <PInputField
                :value="state.userProfile.email"
                label="Email"
                @update-event="(val) => (state.userProfile.email = val)"
              />
            </v-col>
            <v-col>
              <p>Role</p>
              <PAutocomplete
                :select-text="state.userProfile.role"
                :items="roles"
                @field-updated="(val: string) => (state.userProfile.role = val)"
              ></PAutocomplete>
            </v-col>
          </v-row>
        </div>
        <v-row>
          <PSecondaryButton
            class="mt-3 mb-5 ml-3"
            @click="$router.push(RouterPath.AdministratorPage)"
            >Back</PSecondaryButton
          >
          <v-spacer></v-spacer>
          <PPrimaryButton class="mt-3 mb-5 mr-3" @click="submit"
            >Create user</PPrimaryButton
          >
        </v-row>
      </div>
      <UserDisplay
        v-else
        :email="userProfile.email"
        @exit="router.push(RouterPath.AdministratorPage)"
      ></UserDisplay>
    </v-form>
  </StandardCardPageContainer>
</template>

<script setup lang="ts">
import PPrimaryButton from "@/components/custom/buttons/PPrimaryButton.vue";
import PSecondaryButton from "@/components/custom/buttons/PSecondaryButton.vue";
import { ref } from "vue";
import { UserProfile } from "@/models/userProfile";
import { UserProfileType } from "@/models/enum/userProfileType";
import { required, email } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import { genericError } from "@/modules/utilities";
import { createUserProfile } from "@/services/userProfileAdminService";
import StandardCardPageContainer from "@/components/containers/StandardCardPageContainer.vue";
import { RouterPath } from "@/models/enum/routerPath";
import PInputField from "@/components/custom/PInputField.vue";
import PAutocomplete from "@/components/custom/PAutocomplete.vue";
import router from "@/router";
import { useSnackBarStore } from "@/stores/snackBarStore";
import UserDisplay from "./UserDisplay.vue";

const snackbarStore = useSnackBarStore();

const roles = UserProfileType.AllowedUserProfileRoles;

const userProfile = ref(new UserProfile());
const viewUser = ref(false);

const state = ref({
  userProfile,
});

const rules = {
  userProfile: {
    email: { required, email },
    role: { required },
  },
};

const v = useVuelidate(rules, state);

async function submit(): Promise<void> {
  const validForm = await v.value.$validate();

  if (!validForm) {
    snackbarStore.showError("Invalid user");
    return;
  }

  try {
    await createUserProfile(state.value.userProfile);
    snackbarStore.showSuccess("Successfully created user");
    viewUser.value = true;
  } catch (error) {
    snackbarStore.showError(genericError);
  }
}
</script>
